import { isMacAppStore } from '@/lib/appDistribution';
import React from 'react';
import { View, StyleSheet } from 'react-native';
import PromoBanner from '@/components/Banner/PromoBanner';
import AnnouncementBanner from '@/components/Banner/AnnouncementBanner';
import { useUserBanners } from '@/hooks/useUserBanners';

const styles = StyleSheet.create({
  container: {
    width: '100%',
    gap: 8,
  },
});

function BannerPlacement({ placement, isCompact = false, style, bannerStyle, limit = 1 }) {
  const { getBannersForPlacement, markSeen, markClicked, dismiss } = useUserBanners();
  const banners = getBannersForPlacement(placement);

  if (isMacAppStore() || !banners.length) return null;

  const visibleBanners = banners.slice(0, limit);
  const BannerComponent = (placement === 'home-banner' || placement === 'chat-banner') ? AnnouncementBanner : PromoBanner;

  return (
    <View style={[styles.container, style]}>
      {visibleBanners.map((banner) => (
        <BannerComponent
          key={banner.id}
          banner={banner}
          onMarkSeen={markSeen}
          onCtaClick={markClicked}
          onDismiss={dismiss}
          isCompact={isCompact}
          style={bannerStyle}
        />
      ))}
    </View>
  );
}

export default React.memo(BannerPlacement);
